'use strict';

frontendApp.controller('ImportCtrl', ['$rootScope', '$scope', '$location', 'HttpService', 'AccountService', 'ProjectService', 'CustodianService', 'CollectionService', 'ConfigService', 'NotificationService', 'NavigationService', function($rootScope, $scope, $location, HttpService, AccountService, ProjectService, CustodianService, CollectionService, ConfigService, NotificationService, NavigationService) {

  $scope.source = {
    valid: "",
    uploadFiles: {
      active: false,
      file: null
    },
    upload: {
      progress: 0,
      bytesLoaded: 0,
      bytesTotal: 0
    }
  };

  $scope.$on('fileDropped', function(evt, file) {
    $scope.source.valid = "valid";
    $scope.source.uploadFiles.file = file;
  });

  $scope.$on('droppedFileRemoved', function(evt) {
    $scope.source.valid = "";
    $scope.source.uploadFiles.file = null;
  });

  $scope.uploadImport = function(project) {

    if ($scope.source.uploadFiles.file) {
      $scope.source.uploadFiles.active = true;

      var url = ConfigService.getServerBaseUrl() +
        "/project/" +
        project.id +
        "/loadFile";

      var formData = new FormData();
      formData.append('file', $scope.source.uploadFiles.file);

      $scope.source.upload.progress = 0;
      $scope.source.upload.bytesLoaded = 0;
      $scope.source.upload.bytesTotal = 0;

      HttpService.$ajax(url, {
        type: 'POST',
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
        xhr: function () {
          var myXhr = $.ajaxSettings.xhr();
          if (myXhr.upload) {
            myXhr.upload.addEventListener('progress', function (ev) {
              if (ev.lengthComputable) {
                var percentUploaded = Math.floor(ev.loaded * 100 / ev.total);

                $scope.$apply(function () {
                  $scope.source.upload.bytesLoaded = ev.loaded;
                  $scope.source.upload.bytesTotal = ev.total;
                  $scope.source.upload.progress = percentUploaded;
                });
              }
            }, false);
          }
          return myXhr;
        },
        success: function (resource) {
          console.log('SUCCESS! ' + resource);

          $scope.$apply(function () {

            var name = $scope.source.uploadFiles.file.name;

            $scope.source.uploadFiles.active = false;
            $scope.source.uploadFiles.file = null;
            $scope.source.valid = "";

            NotificationService.addSuccess({
              title: 'Load file imported started',
              description: 'Created with ' + name,
              timeout: 5000
            });

          });
        },
        error: function () {
          $scope.$apply(function () {
            $scope.source.uploadFiles.active = false;

            NotificationService.addError({
              title: 'Error uploading load file',
              description: "That's embarrassing, please try again later",
              timeout: 5000
            });
          });
        }
      });

    }

  };


}]);

